import { draftHasCustomContents } from 'pages/bulletin/pdf/utils/bulletinPdfCustomContent';

export const BULLETIN_PDF_INTRO_TITLE_ID = 'bulletin_pdf_intro_title';
export const BULLETIN_PDF_INTRO_DESCRIPTION_ID =
  'bulletin_pdf_intro_description';

export function normalizePdfTemplate(template) {
  return template === 'classic' ? 'classic' : 'default';
}

export function getBulletinPdfIntroFieldIds() {
  return {
    titleId: BULLETIN_PDF_INTRO_TITLE_ID,
    descriptionId: BULLETIN_PDF_INTRO_DESCRIPTION_ID,
  };
}

export function draftHasContent(draft) {
  if (!draft) return false;
  if ((draft.removedIds || []).length > 0) return true;
  if (draft.introductionEnabled) return true;
  if (draftHasCustomContents(draft)) return true;

  const fields = draft.fields || {};
  const { titleId, descriptionId } = getBulletinPdfIntroFieldIds();
  if (Object.prototype.hasOwnProperty.call(fields, titleId)) return true;
  if (Object.prototype.hasOwnProperty.call(fields, descriptionId)) return true;

  return Object.keys(fields).length > 0;
}

export function clearIntroFields(fields) {
  const { titleId, descriptionId } = getBulletinPdfIntroFieldIds();
  const next = { ...fields };
  delete next[titleId];
  delete next[descriptionId];
  return next;
}
